import React, {useState, useEffect} from 'react';
import "../../../css/pages/careers.scss";
import careers from "../../../images/careers/careers.png";

function Careers() {
    return (
        <div className='careers-container'>
           <p className='title-text'>Careers</p>
           <div className='content-class'>
                <img className='career-image' src={careers} />
                <p className='check-back'>Please check back soon for job opportunities at RS11</p>
           </div>
        </div>
    )
}

export default Careers;